import { render, staticRenderFns } from "./ForgotMembership.vue?vue&type=template&id=31a09bc8&"
import script from "./ForgotMembership.vue?vue&type=script&lang=ts&"
export * from "./ForgotMembership.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports